export const UPDATE_ASSETS_GROUPS = `
  mutation Asset($input: UpdateAssetsGroupsInput!) {
    asset {
      updateAssetsGroups(input: $input) {
        success
        message
      }
    }
  }
`;